import apiForluz from './api';

export class QuestionarioPerfilInvestimentoService {
  setResultadoQuestionario = async (matricula, total, respostas, token) => {
    await apiForluz.post('InserirRespostaQuestionario', {
      matricula,
      total,
      respostas,
      token,
    });
  };

  getResultadoQuestionario = async (matricula, token) => {
    const response = await apiForluz.get(
      `ObterResultadoQuestionario?matricula=${matricula}&token=${token}`
    );

    return response.data[0].Resultado;
  };
}
